import { modalController } from "@ionic/vue";
import AddFileModal from "@/components/modals/AddFileModal.vue";
import { useCloseModal } from "./useCloseModal";
import { localLogger } from "@/utils/localLogger";
import { toastController } from "@ionic/core";
import { useI18n } from "./useI18n";

export const useAddFileItem = (
  addFile: (image: any) => void,
  mixpanelStr: string
) => {
  const { closeModal } = useCloseModal();
  const { t } = useI18n();
  const addFileItem = async () => {
    const modal = await modalController.create({
      component: AddFileModal,
      canDismiss: true,
      mode: "ios",
      breakpoints: [0, 1],
      initialBreakpoint: 1,
      componentProps: {
        mixpanelStr,
        onDone: async (image: any) => {
          closeModal(modal);
          if (!image) return;
          try {
            await addFile(image);
          } catch (error: Error | any) {
            await localLogger.log(
              `Error while adding file : ${JSON.stringify(error)}`
            );

            const toast = await toastController.create({
              message: t("common.unknownErrorRetry"),
              duration: 2000,
              color: "danger",
            });
            return toast.present();
          }
        },
        onCancel: () => closeModal(modal),
      },
    });
    await modal.present();
  };

  return {
    addFileItem,
  };
};
